// extracted by mini-css-extract-plugin
module.exports = {"body":"link-card-body_body__ALF8d","title":"link-card-body_title__93Qnh","date":"link-card-body_date__mP9vJ"};